export default {
  CUSTOM_USER_01: "CUSTOM_USER_01"
};
